import React from 'react';
import { Link } from 'react-router-dom';
import SectionBackground from './SectionBackground';
import HeroHighlightCard from './HeroHighlightCard';

const highlights = [
  { value: '11+', label: 'Years of Expertise' },
  { value: '24h', label: 'Filing Turnaround' },
  { value: '14k+', label: 'Trademarks Filed' },
  { value: '300+', label: 'Five-Star Google Reviews' },
];

const Hero = () => {
  return (
    <SectionBackground
      image="/images/bg-hero.svg"
      overlay="dark"
      minHeight="min-h-[min(520px,70vh)]"
      className="pt-40 md:pt-48 pb-28 md:pb-32 lg:pb-36"
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-10 xl:gap-14 items-end">
          <div className="xl:col-span-7 text-white text-left">
            <p className="text-primary-light font-semibold text-sm uppercase tracking-wider mb-4">
              TM RUSH®, Brazil
            </p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Trademark Registration and Watch in Brazil
            </h1>
            <p className="text-lg text-gray-200 leading-relaxed max-w-2xl mb-8">
              Specialist Brazilian trademark representation for foreign IP firms and global companies.
              Fixed prices, filing within 24 business hours and 12 months of Brazil Trademark Watch included with every filing.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/order"
                className="inline-block bg-primary text-white px-8 py-3 rounded-xl hover:bg-primary-hover font-semibold shadow-md"
              >
                Start Application
              </Link>
              <Link
                to="/brazil-watch"
                className="inline-block bg-white/10 text-white px-8 py-3 rounded-xl hover:bg-white/20 font-semibold border border-white/25 backdrop-blur-sm"
              >
                Watch my brand · US$ 150/yr
              </Link>
            </div>
          </div>

          <div className="xl:col-span-5 grid grid-cols-2 gap-4">
            {highlights.map((item) => (
              <HeroHighlightCard key={item.label} value={item.value} label={item.label} />
            ))}
          </div>
        </div>
      </div>
    </SectionBackground>
  );
};

export default Hero;
